module.exports = __webpack_public_path__ + "static/media/gota.95b08ac7.svg";